
const FOCUSABLE_SELECTOR =
  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), [role="button"], .button:not([disabled])'

export default {
  data() {
    return {
      _previousActiveElement: null,
      _boundKeydownHandler: null
    }
  },

  mounted() {
    // Save whatever had focus before this modal opened, prioritizing the explicit triggerElement prop
    this._previousActiveElement = this.triggerElement || document.activeElement

    // Bind the keydown handler to preserve 'this' context
    this._boundKeydownHandler = (e) => this._handleModalKeydown(e)
    
    // Attach to document so Tab is caught even when focus escapes the modal
    document.addEventListener('keydown', this._boundKeydownHandler)

    // Move focus inside modal after DOM settles
    this.$nextTick(() => {
      this._moveFocusInside()
    })
  },

  beforeDestroy() {
    // Remove the bound event listener
    if (this._boundKeydownHandler) {
      document.removeEventListener('keydown', this._boundKeydownHandler)
    }

    // Return focus to the element that opened the modal
    if (this._previousActiveElement && typeof this._previousActiveElement.focus === 'function') {
      this._previousActiveElement.focus()
    }
  },

  methods: {
    // Target .modal-container specifically — not the outer mask/background wrapper
    _getModalContainer() {
      return this.$el.querySelector('.modal-container') || this.$el
    },

    _getFocusableElements() {
      const container = this._getModalContainer()
      return Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter(
        el => !el.disabled && !el.closest('[hidden]')
      )
    },

    _moveFocusInside() {
      const focusable = this._getFocusableElements()
      if (focusable.length > 0) {
        focusable[0].focus()
      }
    },

    _handleModalKeydown(e) {
      if (e.key === 'Escape') {
        this.$emit('close')
        return
      }

      if (e.key !== 'Tab') return

      const focusable = this._getFocusableElements()
      if (focusable.length === 0) return

      const first     = focusable[0]
      const last      = focusable[focusable.length - 1]
      const container = this._getModalContainer()

      // If focus escaped outside the modal container, pull it back immediately
      if (!container.contains(document.activeElement)) {
        e.preventDefault()
        first.focus()
        return
      }

      if (e.shiftKey) {
        // Shift+Tab on first element → wrap to last
        if (document.activeElement === first) {
          e.preventDefault()
          last.focus()
        }
      } else {
        // Tab on last element → wrap to first
        if (document.activeElement === last) {
          e.preventDefault()
          first.focus()
        }
      }
    }
  }
}
